import { render, staticRenderFns } from "./Allequpt.vue?vue&type=template&id=22362a63&scoped=true"
import script from "./Allequpt.vue?vue&type=script&lang=js"
export * from "./Allequpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22362a63",
  null
  
)

export default component.exports